

















import { defineComponent, reactive, toRefs } from '@vue/composition-api'

const getComponentState = () => {
    const state = reactive({
        isOpen: false,
    })

    return toRefs(state)
}

export default defineComponent({
    props: {
        howto: { type: Object, required: true },
    },
    setup() {
        const state = getComponentState()

        const toggleHandler = () => {
            state.isOpen.value = !state.isOpen.value
        }

        return {
            ...state,
            toggleHandler,
        }
    },
})
